import { createStore } from 'vuex'
import user from './modules/user'
import common from './modules/common'
import staging from './modules/staging'

const store = createStore({
  modules: {
    user,
    staging,
    common,
  },
})

export default store
